import { GetBookingMyMscResponse, PassengerI, TransferI } from '@msc-b2c/interfaces/interfaces';
import { getPassengerItemsByCabinId } from './stateroomGenericUtils';
import { replacePlaceholders } from '@msc-b2c/shared-utils';
import { TransferCustomDataI } from '@msc-b2c/interfaces/types';

export const getTranferItemsByCabinId = (
  cabinId: string,
  bookingData: GetBookingMyMscResponse
): TransferI[] => {
  return bookingData.transfers?.filter((transfer) => transfer.relatedItem?.id === cabinId) || [];
};

export const getTransferCustomDataInfo = (
  cabinId: string,
  bookingData: GetBookingMyMscResponse
): TransferCustomDataI[] => {
  const transfers: TransferI[] = getTranferItemsByCabinId(cabinId, bookingData);
  const passengers: PassengerI[] = getPassengerItemsByCabinId(cabinId, bookingData);

  return transfers.map((transfer) => {
    const passengerData = passengers
      .filter((p) => transfer.passengers?.some((tp) => tp.id === p.id))
      .map((p) => ({
        id: p.id,
        name: p.name,
        surname: p.surname,
        passengerLabel: '',
      }));

    return {
      code: transfer.id ?? '',
      passengers: passengerData,
      departureLocation: transfer.departure.location.name ?? '',
      arrivalLocation: transfer.arrival.location?.name ?? '',
      arrivalDate: transfer.arrival.date ?? '',
      description: transfer.description ?? '',
    };
  });
};

export const getTransferEnrichedCustomDataInfo = (
  cabinId: string,
  bookingData: GetBookingMyMscResponse,
  placeholders: Record<string, string>,
  labelsMap: Record<string, { description?: string; specialInstructions?: string }>
): TransferCustomDataI[] => {
  //TODO: Add logic for the trains section regarding the passengers
  const transfers = getTransferCustomDataInfo(cabinId, bookingData);
  transfers.forEach((transfer) => {
    const transferCode = transfer.code;
    transfer.description = labelsMap[transferCode]?.description ?? transfer.description;
    transfer.longDescription =
      labelsMap[transferCode]?.specialInstructions ??
      replacePlaceholders(placeholders.transferDescriptionPlaceholder, {
        departureLocation: transfer.departureLocation,
        arrivalLocation: transfer.arrivalLocation,
        arrivalDate: transfer.arrivalDate,
      });
  });

  return transfers;
};
